var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7895 5.89474H10.3158V3.68421H8.10526V2.21053H10.3158V0H11.7895V2.21053H14V3.68421H11.7895V5.89474Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2632 7.36842H11.7895V9.57895H3.93032C3.61132 9.57809 3.30079 9.6816 3.04611 9.87368L1.47368 11.0526V2.21053H6.63158V0.736842H1.47368C0.659791 0.736842 0 1.39663 0 2.21053V14L3.53684 11.3474C3.79165 11.1555 4.1021 11.052 4.42105 11.0526H11.7895C12.6034 11.0526 13.2632 10.3928 13.2632 9.57895V7.36842Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatMobile);
export default __webpack_public_path__ + "static/media/NewChatMobile.08b76d0aba78b157bacc24a6841fa017.svg";
export { ForwardRef as ReactComponent };